import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaPlus, FaTimes, FaMinus, FaCheck, FaSave } from "react-icons/fa";
import { CiWarning } from "react-icons/ci";
import { ToastContainer } from "react-toastify";
import { showToast } from "../../clinic/utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import CreatableSelect from "react-select/creatable";
import ConfirmBox from "../components/ConfirmBox";
import {
  getPatientDetailsWithContactInfo,
  fetchInvoiceDataById,
  serviceFetchDoctorList,
} from "../services/api";
import {
  fetchServicesByClinicIdAndName,
  saveBillingData,
  fetchClinicBasicDetails,
  fetchClinicContactDetails,
  updateInvoiceData,
  saveInvalidatePaymentData,
  saveInvalidateBillData,
} from "../services/billingApi";
import {
  getClinicIdFromToken,
  getToken,
  getValueFromToken,
} from "../utils/tokenUtils";
import DiscountToggle from "../components/DiscountToggle";
import { IoCloseOutline } from "react-icons/io5";
import { generateInvoicePDF } from "../../prescription/services/generateInvoicePDF";
import InvoicePreviewModal from "../components/InvoicePreviewModal";
import { serviceGetClinicAddressDetails } from "../services/profileApi";
import CustomSelect from "../components/CustomSelect";
import { paymentMethodOptions } from "../utils/commonData";
import InputComponent from "../components/InputComponent";

// const AddServiceButton = ({ Status,onClick }) => {
//   return (
//     <>
//       {Status === "Valid" && (
//         <button
//           onClick={onClick}
//           className="inline-flex items-center px-4 py-2 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest bg-blue-500 hover:bg-blue-600 active:bg-blue-700 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue transition ease-in-out duration-150"
//         >
//           <FaPlus className="h-4 w-4 mr-1" />
//           Add Services
//         </button>
//       )}
//     </>
//   );
// };
const BillingForm = ({
  patientId,
  appointmentDate,
  onClose,
  invoice_id = 0,
  selectedAppointmentDoctor,
  reason
}) => {
  const [patientDetails, setPatientDetails] = useState({
    name: "",
    uhid: "",
    phoneNumber: "",
    paymentStatus: "Unpaid",
  });
  const navigate = useNavigate();

  const [doctors, setDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [newServices, setNewServices] = useState([]);
  const [fetchedServices, setFetchedServices] = useState([]);
  const [isPercentage, setIsPercentage] = useState(false);
  const [showInvoicePreview, setShowInvoicePreview] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  const [finalInvoiceData, setFinalInvoiceData] = useState([]);
  const [finalInvoiceDataUp, setFinalInvoiceDataUp] = useState([]);
  const [invoicePdfBlob, setInvoicePdfBlob] = useState(null);
  const [issuedDate, setIssuedDate] = useState(null);
  const [invoicePdfBlobUp, setInvoicePdfBlobUp] = useState(null);
  const [clinicDetails, setClinicDetails] = useState({});
  const [totalPaid, setTotalPaid] = useState(0);
  const [hasSetDefaultService, setHasSetDefaultService] = useState(false);
  const [defaultDoctor, setDefaultDoctor] = useState(selectedAppointmentDoctor);
  const [isDiscountInPercentage, setIsDiscountInPercentage] = useState(true);
  const [selectedDate, setSelectedDate] = useState(
    appointmentDate ? new Date(appointmentDate) : new Date()
  );
  const [additionalDiscountAmount, setAdditionalDiscountAmount] = useState(0);
  const [selectedBillingDoctor, setSelectedBillingDoctor] = useState(
    selectedAppointmentDoctor
  );
  const [services, setServices] = useState([]);
  const [payment, setPayment] = useState({})
  const [Title, setTitle] = useState()
  const [paymentDetails, setPaymentDetails] = useState([
    {
      payment_method: "Cash",
      number: "",
      amount: 0,
      payment_channel: "Cash",
      notes: "",
    },
  ]);
  const [paymentStatus, setPaymentStatus] = useState("Unpaid");

  const [Status, setStatus] = useState("Valid");
  const [additionalDiscount, setAdditionalDiscount] = useState(0);
  const [isAddServiceButtonDisabled, setIsAddServiceButtonDisabled] = useState(false);
  const AddServiceButton = ({ onClick }) => {
    return (
      <>
        {Status === "Valid" && (
          <button
            onClick={onClick}
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest bg-blue-500 hover:bg-blue-600 active:bg-blue-700 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue transition ease-in-out duration-150"
          >
            <FaPlus className="h-4 w-4 mr-1" />
            Add Services
          </button>
        )}
      </>
    );
  };
  const fetchPatientDetails = async () => {
    try {
      const response = await getPatientDetailsWithContactInfo(patientId);
      if (response.patient) {
        const { patient } = response;
        const { userDetails } = patient;
        let phoneNumber = "";
        if (response.primary_phone_number) {
          phoneNumber = `+91 ${response.primary_phone_number}`;
        } else if (userDetails.primary_phone_number) {
          phoneNumber = userDetails.primary_phone_number;
        }

        setPatientDetails({
          name: `${userDetails.first_name} ${userDetails.last_name}`,
          uhid: `VX${patient.patient_id.toString().padStart(5, "0")}`,
          phoneNumber: phoneNumber,
          paymentStatus: "",

        });
      }
    } catch (error) {
      console.error("Error fetching patient details:", error);
    }
  };

  const fetchDoctors = async () => {
    const userId = getValueFromToken("user_id");
    try {
      const response = await serviceFetchDoctorList(userId, true);
      if (response?.status) {
        const doctors = response?.data?.doctors || [];
        const allDoctorsOption = {
          doctor_id: "all",
          first_name: "All Doctors",
          last_name: "",
        };
        setDoctors([allDoctorsOption, ...doctors]);
        setSelectedDoctor("all");
      } else {
        console.error("Failed to fetch doctors list");
      }
    } catch (error) {
      console.error("Error fetching doctors list:", error);
    }
  };

  const fetchClinicDetails = async () => {
    const clinicId = getClinicIdFromToken();
    const userId = getValueFromToken("user_id");

    const [clinicName, contactInfo, addressDetails] = await Promise.all([
      fetchClinicBasicDetails(clinicId),
      fetchClinicContactDetails(userId),
      serviceGetClinicAddressDetails({ userId }),
    ]);
    setClinicDetails({
      name: clinicName || "N/A",
      address: addressDetails
        ? `${addressDetails.street_1 || ""}, ${
          addressDetails.street_2 || ""
        }, ${addressDetails.city || ""}, ${addressDetails.state || ""}, ${
          addressDetails.country || ""
        }, ${addressDetails.pin_code || ""}`
        : "N/A",
      phone: contactInfo ? contactInfo.primary_phone_number : "N/A",
      email: contactInfo ? contactInfo.primary_email_id : "N/A",
    });
  };

  const handleFetchInvoiceDataById = async (id) => {
    const response = await fetchInvoiceDataById(id);
    if (response?.status) {
      const Status = response.data.isInvalidated ? "Invalid" : "Valid";
      setIsAddServiceButtonDisabled(Status === "Invalid");
      setStatus(Status);
      setInvoiceData(response?.data);
    }
  };

  useEffect(() => {
    if (invoiceData && invoiceData.issued_date) {
      setIssuedDate(new Date(invoiceData.issued_date)); // Set the issued date if it exists in the loaded invoice data
      setSelectedDate(new Date(invoiceData.issued_date)); // Also set this as the selected date
    }
  }, [invoiceData]);

  useEffect(() => {
    if (invoiceData && invoiceData.invoiceItems && doctors.length > 0) {
      const firstItem = invoiceData.invoiceItems[0];
      if (firstItem.doctor) {
        const selectedDoctor = doctors.find(
          (doc) => doc.doctor_id === firstItem.doctor.doctor_id
        );
        if (selectedDoctor) {
          setSelectedBillingDoctor(selectedDoctor);
        }
      }
      const modifiedServices = (invoiceData?.invoiceItems || []).map((item) => {
        let doctor = {};

        if (item.doctor === null) {
          doctor = {
            doctor_id: "all",
            doctor_name: "All Doctors",
          };
        } else {
          doctor = {
            doctor_id: item?.doctor?.doctor_id,
            doctor_name:
              item?.doctor?.user?.first_name +
              " " +
              item?.doctor?.user?.last_name,
          };
        }

        item.doctor = doctor;

        // Calculate total amount
        item.total_amount = item.quantity * (item.unit_price - item.discount);
        return item;
      });

      setServices(modifiedServices);
      setDefaultDoctor(modifiedServices[0].doctor);
    }

    if (invoiceData && invoiceData.payments) {
      setPaymentDetails(invoiceData.payments);
      const totalPaid = invoiceData.payments.reduce(
        (total, payment) => total + parseFloat(payment.amount),
        0
      );
      setTotalPaid(totalPaid);
      setPaymentStatus(invoiceData.status);
    }
    if (invoiceData && invoiceData.discount_amount) {
      setAdditionalDiscountAmount(invoiceData.discount_amount);
    }
  }, [invoiceData, doctors]);

  useEffect(() => {
    if (additionalDiscount !== 0) {
      const newAdditionalDiscountAmount =
        calculateAdditionalDiscount(additionalDiscount);
      setAdditionalDiscountAmount(newAdditionalDiscountAmount);
    }
  }, [additionalDiscount, isDiscountInPercentage]);

  useEffect(() => {
    if (invoice_id) {
      handleFetchInvoiceDataById(invoice_id);
    }
    fetchDoctors();
    fetchClinicDetails();
    handleServiceInputChange("");
  }, []);

  useEffect(() => {
    if (patientId) {
      fetchPatientDetails();
    }
  }, [patientId]);

  useEffect(() => {
    if (
      !hasSetDefaultService &&
      selectedAppointmentDoctor &&
      fetchedServices.length > 0
    ) {
      const defaultService = fetchedServices.find(
        (service) =>
          service.doctor_id === selectedAppointmentDoctor.doctor_id &&
          service.name === "Consultation"
      );
      if (defaultService) {
        setServices([
          {
            description: defaultService.name,
            doctor: selectedAppointmentDoctor,
            quantity: 1,
            unit_price: defaultService.default_price,
            discount: 0,
            total_amount: defaultService.default_price,
          },
        ]);
        setPaymentDetails([
          {
            payment_method: "Cash",
            amount: defaultService.default_price,
            payment_channel: "Cash",
            notes: "",
          },
        ]);
        setTotalPaid(defaultService.default_price);
        setHasSetDefaultService(true);
      }
    }
  }, [fetchedServices, selectedAppointmentDoctor, hasSetDefaultService]);

  const handleServiceChange = async (index, field, value) => {
    if (field === "quantity" && value <= 0) {
      showToast("Quantity cannot be less than 1", "error");
      return;
    }

    const newServicesArray = [...services];
    newServicesArray[index][field] = value;

    if (field === "description") {
      const selectedOption = fetchedServices.find(
        (service) => service.name === value
      );
      if (selectedOption) {
        newServicesArray[index].doctor = {
          doctor_id: selectedOption.doctor_id,
        };
        newServicesArray[index].quantity = 1;
        newServicesArray[index].unit_price = selectedOption.default_price || 0;
        newServicesArray[index].discount = 0;
        newServicesArray[index].total_amount =
          selectedOption.default_price || 0;
      } else {
        newServicesArray[index].doctor = {
          doctor_id: "all",
          doctor_name: "All Doctors",
        };
        newServicesArray[index].quantity = 1;
        newServicesArray[index].unit_price = 0;
        newServicesArray[index].discount = 0;
        newServicesArray[index].total_amount = 0;
      }
    }

    if (field === "doctor") {
      newServicesArray[index].doctor = value;
    }
    if (
      field === "unit_price" ||
      field === "discount" ||
      field === "quantity"
    ) {
      const unit_price = parseFloat(newServicesArray[index].unit_price);
      const discount = parseFloat(newServicesArray[index].discount);
      const quantity = parseInt(newServicesArray[index].quantity);

      // Check for invalid values
      if (unit_price < 0) {
        showToast("Amount cannot be negative", "error");
        return;
      }
      if (discount < 0) {
        showToast("Discount cannot be negative", "error");
        return;
      }
      if (quantity < 1) {
        showToast("Quantity cannot be less than 1", "error");
        return;
      }

      newServicesArray[index].total_amount = quantity * (unit_price - discount);
    }

    setServices(newServicesArray);
  };

  const handleAddService = () => {
    setServices([
      ...services,
      {
        description: "",
        quantity: 1,
        unit_price: 0,
        discount: 0,
        total_amount: 0,
        doctor: selectedDoctor,
      },
    ]);
  };

  const handleAddPayment = (Status) => {
    setPaymentDetails([
      ...paymentDetails,
      { payment_method: "", amount: 0, payment_channel: "", notes: "" },
    ]);
  };

  const handleRemovePayment = (index) => {
    const payment = paymentDetails[index];

    // Only remove the payment if it does not have a payment_id
    if (!payment.payment_id) {
      const newPayments = [...paymentDetails];
      newPayments.splice(index, 1);
      setPaymentDetails(newPayments);
    }
  };

  const handlePaymentChange = (index, field, value) => {
    const newPaymentDetails = [...paymentDetails];
    newPaymentDetails[index][field] = value;

    // Auto-update payment_channel when payment_method changes
    if (field === "payment_method") {
      if (value === "Cash") {
        newPaymentDetails[index]["payment_channel"] = "Cash";
      } else if (value === "UPI") {
        newPaymentDetails[index]["payment_channel"] = "GPay";
      }
    }

    if (field === "amount") {
      const totalPaid = newPaymentDetails.reduce((total, payment) => {
        const paymentAmount =
          payment.amount === "" ? 0 : parseFloat(payment.amount);
        return total + (isNaN(paymentAmount) ? 0 : paymentAmount);
      }, 0);

      if (!isNaN(totalPaid)) {
        setTotalPaid(totalPaid);
      }

      if (totalPaid > grandTotal) {
        showToast(
          "Total paid amount cannot be greater than the grand total.",
          "error"
        );
        return;
      }
    }

    setPaymentDetails(newPaymentDetails);
  };
  function validateForm() {
    // Validate service details
    if (services.length === 0) {
      return "Please add at least one service.";
    }

    for (const service of services) {
      if (!service.description) {
        return "Please fill in the service description.";
      }
      if (service.quantity <= 0) {
        return "Quantity must be greater than 0.";
      }
      if (!service.unit_price) {
        return "Please fill in the unit price.";
      }
      if (!(service.doctor && service?.doctor?.doctor_id !== -1)) {
        return "Please select a doctor.";
      }
    }

    // Validate payment details
    for (const payment of paymentDetails) {
      if (payment.amount <= 0) {
        return "Payment amount must be greater than 0.";
      }
      if (!payment.payment_method) {
        return "Please select a payment method.";
      }
    }

    // Validate additional discount, grand total and total paid
    if (additionalDiscount < 0) {
      return "Discount amount cannot be negative.";
    }

    if (additionalDiscount > grandTotal) {
      return "Discount amount cannot be greater than the grand total.";
    }

    const totalPaid = paymentDetails.reduce(
      (total, payment) => total + Number(payment.amount),
      0
    );
    if (totalPaid > grandTotal) {
      return "Total paid amount cannot be greater than the grand total.";
    }

    return true;
  }

  const handleSave = async () => {
    const validationResult = validateForm();
    if (validationResult !== true) {
      showToast(validationResult, "error");
      return;
    }

    const paidAmount = paymentDetails.reduce(
      (total, payment) => total + parseFloat(payment.amount),
      0
    );

    // Prepare the invoice data
    const invoiceData = {
      patientId,
      clinicId: getClinicIdFromToken(),
      issuedDate: selectedDate || new Date(),
      doctorName: selectedBillingDoctor?.doctor_name,
      doctorId: selectedBillingDoctor?.doctor_id,
      totalAmount: totalAmount,
      discountAmount: additionalDiscountAmount,
      paidAmount: paidAmount,
      lineItems: services.map((service) => ({
        invoice_item_id: service.invoice_item_id,
        description: service.description,
        quantity: service.quantity,
        unitPrice: service.unit_price,
        discount: service.discount,
        doctorId: selectedBillingDoctor?.doctor_id || null,
        doctorName: selectedBillingDoctor?.doctor_name || null,
      })),
      paymentMethod: paymentDetails[0].payment_method,
      newServices: newServices.map((service) => ({
        description: service.description,
        amount: service.unit_price || 0,
        doctor: service.doctor || null,
      })),
      paymentDetails: paymentDetails.map((payment) => ({
        payment_id: payment.payment_id,
        amount: payment.amount,
        payment_method: payment.payment_method,
        payment_channel: payment.payment_channel,
        notes: payment.notes,
      })),
      clinicDetails: clinicDetails,
      patientDetails: {
        name: patientDetails.name,
        uhid: patientDetails.uhid,
        phoneNumber: patientDetails.phoneNumber,
        paymentStatus: calculatePaymentStatus(paidAmount, grandTotal),
      },
    };

    setFinalInvoiceData(invoiceData);
    const invoiceDataUpdate = {
      invoiceId: invoice_id,
      patientId,
      clinicId: getClinicIdFromToken(),
      issuedDate: new Date(),
      totalAmount: totalAmount,
      discountAmount: additionalDiscountAmount,
      paidAmount: paidAmount,
      lineItems: services.map((service) => ({
        invoice_item_id: service.invoice_item_id,
        description: service.description,
        quantity: service.quantity,
        unitPrice: service.unit_price,
        discount: service.discount,
        doctorId: selectedBillingDoctor?.doctor_id,
      })),
      paymentDetails: paymentDetails.map((payment) => ({
        payment_id: payment.payment_id,
        amount: payment.amount,
        payment_method: payment.payment_method,
        payment_channel: payment.payment_channel,
        notes: payment.notes,
      })),
      clinicDetails: clinicDetails,
      patientDetails: {
        name: patientDetails.name,
        uhid: patientDetails.uhid,
        phoneNumber: patientDetails.phoneNumber,
        paymentStatus: calculatePaymentStatus(paidAmount, grandTotal),
      },
    };

    setFinalInvoiceDataUp(invoiceDataUpdate);

    // Generate the invoice PDF
    const pdfBlob = await generateInvoicePDF(invoiceData);
    if (pdfBlob instanceof Blob) {
      setInvoicePdfBlob(pdfBlob);
      setShowInvoicePreview(true);
    } else {
      console.error("Generated PDF is not a valid Blob object");
      showToast("Failed to generate invoice PDF. Please try again.", "error");
    }

    // Generate the invoice PDF
    const pdfBlobUp = await generateInvoicePDF(invoiceDataUpdate);
    if (pdfBlobUp instanceof Blob) {
      setInvoicePdfBlobUp(pdfBlobUp);
      setShowInvoicePreview(true);
    } else {
      console.error("Generated PDF is not a valid Blob object");
      showToast("Failed to generate invoice PDF. Please try again.", "error");
    }
  };

  const handleInvoiceSave = async (whatsappOption = false) => {
    // Save the invoice PDF
    if (invoice_id) {
      const response = await updateInvoiceData(
        finalInvoiceDataUp,
        invoicePdfBlobUp,
        whatsappOption
      );
      if (response?.status) {
        showToast("Invoice saved successfully", "success", {
          position: "top-right",
        });
        setTimeout(() => {
          setShowInvoicePreview(false);
          onClose();
        }, 500);
      } else {
        showToast("Failed to save invoice. Please try again.", "error");
      }
    } else if (invoicePdfBlob instanceof Blob) {
      const response = await saveBillingData(
        finalInvoiceData,
        invoicePdfBlob,
        whatsappOption
      );
      if (response?.status) {
        showToast("Invoice saved successfully", "success", {
          position: "top-right",
          autoClose: 500,
        });
        setTimeout(() => {
          setShowInvoicePreview(false);
          onClose();
        }, 1000);
      } else {
        showToast("Failed to save invoice. Please try again.", "error");
      }
    } else {
      console.error("Invoice PDF blob is not a valid Blob object");
    }
  };

  const handleSaveInvalidateBill = async () => {
    const reason = "incorrect details entered";
    const data = { reason, invoice_id }
    if (invoice_id) {
      console.log("Invalidating bill with data:", data);
      const response = await saveInvalidateBillData(data);
      console.log("Invalidation response:", response);
      if (response?.status) {
        showToast("Bill invalidated successfully", "success", {
          position: "top-right",
        });
        setTimeout(() => {
          onClose();
        }, 500);
      } else {
        showToast(response?.message || "Failed to invalidate bill", "error");
      }
    }
    else
      showToast("You can't invalidate the bill before bill is created", "error")
  };
  const handleSaveInvalidatePayment = async (payment) => {
    const reason = "incorrect details entered";
    let payment_id = payment.payment_id;
    const data = { reason, payment_id }
    if (payment_id) {
      console.log("Invalidating payment with data:", data);
      const response = await saveInvalidatePaymentData(data);
      console.log("Invalidation response:", response);
      if (response?.status) {
        showToast("Payment invalidated successfully", "success", {
          position: "top-right",
        });
        setTimeout(() => {
          onClose();
        }, 500);
      } else {
        showToast(response?.message || "Failed to invalidate payment", "error");
      }
    }
    else {
      showToast("You can't invalidate the payment before bill is created", "error")
    };
  }

  const handleServiceInputChange = async (inputValue) => {
    const response = await fetchServicesByClinicIdAndName(
      getClinicIdFromToken(),
      inputValue
    );
    setFetchedServices(response || []);
  };

  function debouncedHandleServiceInputChange(inputValue) {
    return new Promise((resolve, reject) => {
      try {
        const response = handleServiceInputChange(inputValue);
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  }

  const getServiceOptions = () => {
    return fetchedServices.map((service) => ({
      value: service.name,
      label: service.name,
      price: parseFloat(service.default_price),
    }));
  };

  const handleServiceCreate = (index, newValue) => {
    const newServicesArray = [...services];
    newServicesArray[index].description = newValue;
    newServicesArray[index].amount = newServicesArray[index].amount || 0;
    newServicesArray[index].doctor = selectedDoctor;

    setServices(newServicesArray);
    setNewServices([
      ...newServices,
      {
        description: newValue,
        amount: newServicesArray[index].amount,
        doctor: selectedDoctor,
      },
    ]);
  };

  const handleRemoveService = (index) => {
    const newServicesArray = services.filter((_, i) => i !== index);
    setServices(newServicesArray);
  };

  const calculatePaymentStatus = (totalPaid, grandTotal) => {
    if (isNaN(totalPaid) || isNaN(grandTotal)) {
      return "Unpaid";
    }

    if (totalPaid === 0) {
      return "Unpaid";
    } else if (grandTotal <= totalPaid) {
      return "Paid";
    } else {
      return "Partially Paid";
    }
  };

  const calculateTotalAmount = () => {
    return services.reduce(
      (total, service) => total + service.unit_price * service.quantity,
      0
    );
  };

  const calculateTotalDiscount = () => {
    return services.reduce(
      (total, service) => total + service.discount * service.quantity,
      0
    );
  };

  const calculateAdditionalDiscount = (discount) => {
    if (isDiscountInPercentage) {
      return (
        (discount / 100) * (calculateTotalAmount() - calculateTotalDiscount())
      );
    } else {
      return discount;
    }
  };

  const totalAmount = calculateTotalAmount();
  const totalDiscount = calculateTotalDiscount();
  // const additionalDiscountAmount = calculateAdditionalDiscount(additionalDiscount);
  const grandTotal = totalAmount - totalDiscount - additionalDiscountAmount;

  function formatNumber(num) {
    if (num === "" || isNaN(num)) {
      return "";
    }
    return Number(num) % 1 === 0
      ? Math.floor(Number(num))
      : Number(num)?.toFixed(2);
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 z-50 overflow-y-auto"
      onClick={(e) => e.stopPropagation()} // Prevent closing the modal when clicking inside it
    >
      <div className="min-h-screen px-4 text-center">
        {/* <div
          className="fixed inset-0 bg-black opacity-30"
          onClick={onClose}
        ></div> */}

        <span className="inline-block h-screen align-middle" aria-hidden="true">
          &#8203;
        </span>

        <motion.div
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="inline-block w-full max-w-6xl my-8 overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl"
        >
          <div className="bg-gradient-to-r from-blue-400 to-purple-400 text-white px-8 py-6 relative">
            {" "}
            <h2 className="text-3xl font-bold mb-2">Billing</h2>{" "}
            <p className="text-white">
              Create and manage invoices effortlessly
            </p>{" "}
            <button
              onClick={onClose}
              className="absolute  top-1/2 right-10 -translate-y-1/2 border-transparent text-white  hover:text-gray-700 bg-transparent  hover:bg-white focus:ring-4 focus:outline-none focus:ring-gray-200  px-0 w-10 h-10 inline-flex justify-center items-center rounded-full
             text-5xl  transition ease-in-out duration-300 "
            >
              <IoCloseOutline />
              <span className="sr-only">Close</span>
            </button>
          </div>{" "}
          <div className="px-8 py-6 ">
            {" "}
            <div className="flex justify-between items-center pb-4 border-b border-gray-200">
              {" "}
              <div>
                {" "}
                <label className="block text-sm font-medium text-gray-700 mb-0.5">
                  Name
                </label>{" "}
                <p className="text-lg font-semibold text-gray-900">
                  {patientDetails.name}
                </p>{" "}
              </div>{" "}
              <div>
                {" "}
                <label className="block text-sm font-medium text-gray-700 mb-0.5">
                  UHID
                </label>{" "}
                <p className="text-lg font-semibold text-gray-900">
                  {patientDetails.uhid}
                </p>{" "}
              </div>{" "}
              <div>
                {" "}
                <label className="block text-sm font-medium text-gray-700 mb-0.5">
                  Phone Number
                </label>{" "}
                <p className="text-lg font-semibold text-gray-900">
                  {patientDetails.phoneNumber}
                </p>{" "}
              </div>{" "}
              <div>
                {" "}
                <label className="block text-sm font-medium text-gray-700 mb-0.5">
                  Payment Status
                </label>{" "}
                <div
                  className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                    paymentStatus === "Unpaid"
                    ? "bg-red-100 text-red-800"
                    : paymentStatus === "Paid"
                      ? "bg-green-100 text-green-800"
                      : "bg-yellow-100 text-yellow-800"
                    }`}
                >
                  {paymentStatus === "Unpaid" ? (
                    <FaTimes
                      className="mr-2 h-4 w-4 text-red-400"
                      aria-hidden="true"
                    />
                  ) : paymentStatus === "Paid" ? (
                    <FaCheck
                      className="mr-2 h-4 w-4 text-green-400"
                      aria-hidden="true"
                    />
                  ) : (
                    <CiWarning
                      className="mr-2 h-4 w-4 text-yellow-800"
                      aria-hidden="true"
                    />
                  )}
                  {paymentStatus}
                </div>{" "}
              </div>{" "}
            </div>
            <div className="mb-4 pt-5">
              <div className="flex items-center pb-4 border-b border-gray-200">
                <h3 className="text-2xl font-semibold text-gray-800 mb-4 relative w-1/3">
                  Services
                </h3>
                <div className="flex items-center space-x-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Doctor
                    </label>
                    <CustomSelect
                      value={selectedBillingDoctor?.doctor_id}
                      onChange={(selectedOption) => {
                        const selectedDoctor = doctors.find(
                          (doctor) => doctor.doctor_id === selectedOption.value
                        );
                        setSelectedBillingDoctor({
                          doctor_id: selectedOption.value,
                          doctor_name: `${selectedDoctor?.first_name} ${selectedDoctor?.last_name}`,
                        });
                      }}
                      options={doctors.map((doctor) => ({
                        value: doctor?.doctor_id,
                        label: `${doctor?.first_name} ${doctor?.last_name}`,
                      }))}
                      isSearchable={false}
                      placeholder="Select Doctor"
                      isClearable={false}
                      className={"form_select"}
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="dateInput"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Date
                    </label>
                    <input
                      type="date"
                      id="dateInput"
                      readOnly={!!issuedDate} // Only read-only if issuedDate is set
                      className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                      value={
                        selectedDate
                          ? selectedDate.toISOString().split("T")[0]
                          : ""
                      }
                      onChange={(e) =>
                        setSelectedDate(
                          e.target.value ? new Date(e.target.value) : new Date()
                        )
                      }
                    />
                  </div>

                  <div className={`flex items-center px-3 py-1 rounded-full text-sm font-medium 
    ${Status === "Invalid" ? "bg-red-100 text-red-800" : "bg-green-100 text-green-800"}`}>
                    {Status === "Invalid" ? (
                      <FaTimes className="mr-2 h-4 w-4 text-red-400" aria-hidden="true" />
                    ) : (
                      <FaCheck className="mr-2 h-4 w-4 text-green-400" aria-hidden="true" />
                    )}
                    <span className="mr-1">Status:</span> {Status}
                  </div>

                </div>
              </div>
              <table className="min-w-full divide-y divide-gray-200  border">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/3"
                    >
                      Service
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-20"
                    >
                      Qty
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-24"
                    >
                      Amount
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-24"
                    >
                      Discount
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {services.map((service, index) => (
                    <motion.tr
                      key={index}
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3, delay: index * 0.1 }}
                      className="hover:bg-gray-50"
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <CreatableSelect
                          id="serviceInputSearch"
                          isDisabled={!!service.invoice_item_id} // Disable if the service has an invoice_item_id
                          isClearable
                          value={{
                            value: service.description,
                            label: service.description,
                          }}
                          onChange={(selectedOption) => {
                            const value = selectedOption
                              ? selectedOption.value
                              : "";
                            handleServiceChange(index, "description", value);
                          }}
                          onInputChange={(inputValue) => {
                            debouncedHandleServiceInputChange(inputValue).catch(
                              (error) => {
                                console.error(
                                  "Error handling input change:",
                                  error
                                );
                              }
                            );
                          }}
                          onFocus={() => {
                            debouncedHandleServiceInputChange("").catch(
                              (error) => {
                                console.error(
                                  "Error fetching all values:",
                                  error
                                );
                              }
                            );
                          }}
                          onCreateOption={(newValue) => {
                            if (
                              newValue.trim() !== "" &&
                              !fetchedServices.find(
                                (service) => service.name === newValue
                              )
                            ) {
                              handleServiceCreate(index, newValue);
                            }
                          }}
                          options={getServiceOptions()}
                          placeholder="Select or create..."
                          className="text-base"
                        />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <InputComponent
                          id="quantityAtm"
                          value={service.quantity}
                          disabled={!!service.invoice_item_id}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || !isNaN(value)) {
                              handleServiceChange(
                                index,
                                "quantity",
                                value === "" ? 1 : parseInt(value)
                              );
                            }
                          }}
                          type="text"
                          className="w-full !px-0"
                          inputClassName="!px-0 text-center min-w-[60px] min-h-[38px]"
                        />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <InputComponent
                          id="unitPriceAtm"
                          disabled={!!service.invoice_item_id}
                          value={formatNumber(service.unit_price)}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || !isNaN(value)) {
                              handleServiceChange(
                                index,
                                "unit_price",
                                value === "" ? 0 : parseFloat(value)
                              );
                            }
                          }}
                          type="text"
                          className="w-full !px-0"
                          inputClassName="!px-1.5 text-center min-w-[120px] min-h-[38px]"
                        />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <InputComponent
                          id="discountAtm"
                          disabled={!!service.invoice_item_id}
                          value={formatNumber(service.discount)}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || !isNaN(value)) {
                              handleServiceChange(
                                index,
                                "discount",
                                value === "" ? 0 : parseFloat(value)
                              );
                            }
                          }}
                          type="text"
                          className="w-full !px-0"
                          inputClassName="!px-1.5 text-center min-w-[60px] min-h-[38px]"
                        />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-base font-medium">
                        <span className="whitespace-nowrap">
                          ₹ {formatNumber(service.total_amount)}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right">
                        {index !== 0 && !service.invoice_item_id && (
                          <button
                            type="button"
                            onClick={() => handleRemoveService(index)}
                            className="inline-flex items-center justify-center text-sm font-medium text-red-600 hover:text-red-700 focus:outline-none focus:text-red-700 p-0 min-w-[38px] min-h-[38px]"
                          >
                            <FaMinus className="h-5 w-5" aria-hidden="true" />
                            <span className="sr-only">Remove</span>
                          </button>
                        )}
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="7" className="px-4 py-4 text-right">
                      <AddServiceButton onClick={handleAddService}
                        isDisabled={true} />
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div className="pt-5 pb-4">
              <h3 className="text-2xl font-semibold text-gray-800 mb-4  relative">
                Payment Details
              </h3>

              <div className="border p-6">
                {paymentDetails.map((payment, index) => (
                  <div key={index} className="flex gap-2 mb-4">
                    <div className="w-1/4">
                      {" "}
                      {/* Adjusted width */}
                      <label
                        htmlFor={`method-${index}`}
                        className="mb-1 text-gray-800 font-semibold block"
                      >
                        Method
                      </label>
                      <CustomSelect
                        id={`method-${index}`}
                        value={payment.payment_method}
                        isDisabled={!!payment.payment_id} // Disable the select if payment_id exists
                        onChange={(selectedOption) =>
                          handlePaymentChange(
                            index,
                            "payment_method",
                            selectedOption.value
                          )
                        }
                        options={paymentMethodOptions}
                        isSearchable={false}
                        placeholder="Select Method"
                        isClearable={false}
                      />
                    </div>
                    <div className="w-1/4">
                      {" "}
                      {/* Adjusted width */}
                      <InputComponent
                        label="Amount"
                        id={`amount-${index}`}
                        value={payment.amount}
                        onChange={(e) => {
                          const value = e.target.value;
                          handlePaymentChange(
                            index,
                            "amount",
                            value === "" ? "" : parseFloat(value)
                          );
                        }}
                        type="text"
                        disabled={!!payment.payment_id} // Make the input read-only if payment_id exists
                      />
                    </div>
                    <div className="w-1/4">
                      {" "}
                      {/* Adjusted width */}
                      <InputComponent
                        label="Channel"
                        id={`channel-${index}`}
                        value={payment.payment_channel}
                        onChange={(e) =>
                          handlePaymentChange(
                            index,
                            "payment_channel",
                            e.target.value
                          )
                        }
                        type="text"
                        disabled={!!payment.payment_id} // Make the input read-only if payment_id exists
                      />
                    </div>
                    <div className="w-1/4">
                      {" "}
                      {/* Adjusted width */}
                      <InputComponent
                        label="Notes"
                        id={`notes-${index}`}
                        value={payment.notes}
                        disabled={!!payment.payment_id} // Make the input read-only if payment_id exists
                        onChange={(e) =>
                          handlePaymentChange(index, "notes", e.target.value)
                        }
                        type="text"
                      />
                    </div>
                    <ConfirmBox
                      message={
                        <>
                          Are you sure, you want to invalidate the payment collected?
                          <br />
                          <br />
                          <span style={{ fontSize: 'smaller' }}>
                            Note: This will not invalidate the Bill.
                          </span>
                        </>
                      }
                      onConfirm={() => handleSaveInvalidatePayment(payment)}
                    >
                      {(payment.payment_id) && (
                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          id="invalidPaymentBtn"
                          className="inline-flex justify-center py-1 px-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                        >
                          <FaTimes className="h-4 w-4 mr-2" aria-hidden="true" />
                          Invalidate
                        </motion.button>
                      )}
                    </ConfirmBox>
                    {/* Remove button - hide if payment has ID */}
                    {!payment.payment_id && (
                      <button
                        onClick={() => handleRemovePayment(index)}
                        className="text-red-600 hover:text-red-700 focus:outline-none focus:text-red-700"
                      >
                        <FaMinus className="h-5 w-5" aria-hidden="true" />
                        <span className="sr-only">Remove</span>
                      </button>
                    )}
                  </div>
                ))}
                {Status === "Valid" && (
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleAddPayment}
                  className="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  <FaPlus className="h-4 w-4 mr-2" aria-hidden="true" />
                  Add Payment
                </motion.button>
                )}
              </div>
            </div>
            <div className="pt-9 pb-4">
              <h3 className="text-2xl font-semibold text-gray-800 mb-4  relative">
                Summary
              </h3>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">Total Amount</span>
                  <span className="font-semibold">
                    ₹ {formatNumber(totalAmount)}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Line Item Discount</span>
                  <span className="font-semibold">
                    ₹ {formatNumber(totalDiscount)}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">
                    Additional Discount Amount
                  </span>
                  <span className="font-semibold">
                    ₹ {formatNumber(additionalDiscountAmount)}
                  </span>
                </div>
                <div className="flex justify-between mt-4">
                  <span className="text-xl font-bold text-gray-800">
                    Grand Total
                  </span>
                  <span className="text-2xl font-bold text-blue-600">
                    ₹ {formatNumber(grandTotal)}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Total Paid</span>
                  <span className="font-semibold">
                    ₹ {formatNumber(totalPaid)}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Balance</span>
                  <span className="font-semibold">
                    ₹ {formatNumber(grandTotal - totalPaid)}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* Save button */}
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          {Status=== "Valid" && (
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={handleSave}
          id="billingSaveBtnAtm"
          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
        >
          <FaSave className="h-4 w-4 mr-2" aria-hidden="true" />
          Preview
        </motion.button>
          )}
            <ConfirmBox
              message={
                <>
                  Are you sure you want to invalidate this bill?
                  <br />  <br />
                  <span style={{ fontSize: 'smaller' }}>Note: This will not invalidate the payment collected.</span>
                </>
              }
              onConfirm={handleSaveInvalidateBill}

            >           
                {typeof invoice_id !== 'undefined' && invoice_id !== null && invoice_id !== 0 && Status === "Valid"  && (
               
                < motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  id="invalidBillBtn"
                  className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  <FaTimes className="h-4 w-4 mr-2" aria-hidden="true" />
                  Invalidate
                </motion.button>            
              )}          
            </ConfirmBox>
          </div>

          <div className={`flex items-center px-3 py-1 rounded-full text-sm font-medium 
    ${Status === "Invalid" ? "bg-red-100 text-red-800" : "bg-green-100 text-green-800"}`}>
            {Status === "Invalid" ? (
              <FaTimes className="mr-2 h-4 w-4 text-red-400" aria-hidden="true" />
            ) : (
              <FaCheck className="mr-2 h-4 w-4 text-green-400" aria-hidden="true" />
            )}
            <span className="mr-1">Status:</span> {Status}
          </div>
          <ToastContainer position="bottom-right" autoClose={3000} />{" "}
        </motion.div>
      </div>
      {showInvoicePreview && (
        <InvoicePreviewModal
          onClose={() => setShowInvoicePreview(false)}
          onSave={handleInvoiceSave}
          pdfBlob={invoicePdfBlob}
        />
      )}
    </motion.div>
  );
};

export default BillingForm;
